import loadable from '@loadable/component';

export const AsyncExpiredIncome = loadable(() => import('./ExpiredIncome'));
